export const toLocalTime = (utcDateString) => {
  if (!utcDateString) return '';
  
  // Handle both formats: "2026-06-29 08:40:59" and "2026-06-29T08:40:59Z"
  const normalized = utcDateString.replace(' ', 'T');
  const withZ = normalized.endsWith('Z') ? normalized : normalized + 'Z';
  
  const date = new Date(withZ);
  if (isNaN(date.getTime())) return utcDateString; // fallback to original if invalid
  
  return date.toLocaleString(undefined, {
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
};